import React from 'react'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';

import moment from "moment";
import useAuth from "../../hooks/useAuth";
import Logo from "../../../assets/logo.png";
import { Span } from "../../components/Typography";
import CoverImage from "../../../assets/coverImage.png";
import { formatPhoneNumber, stringReplace } from "../../utils/utils";

import { LoadingButton } from "@mui/lab";
import {
    Box,
    Container,
    Grid,
    Icon,
    styled,
    Typography,
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import PersonIcon from "@mui/icons-material/Person";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import PetsIcon from '@mui/icons-material/Pets';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import TagIcon from '@mui/icons-material/Tag';
import KeyIcon from '@mui/icons-material/Key';
import { tenantPublicPageUrl, tenantServicesPageUrl } from '../../utils/tenantApi';
const MainBox = styled(Box)(({ theme }) => ({
    "& .topHeader": {
        position: "fixed",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "999",
        boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
        "& .logoContainer": {
            padding: "5px 0 2px 0",
            "& img": {
                width: "200px",
            },
        },
        "& .signInBtn": {
            color: "#1976d2",
            fontSize: "1rem",
            fontWeight: "600",
        },
        "& .bodyTxt": {
            color: "#1976d2",
            paddingRight: "0.3rem",
        },
    },
    "& .contentMain": {
        paddingTop: "8rem",
        "& .bookingTitle": {
            textAlign: "center",
            fontWeight: "bold",
            paddingBottom: "1rem",
            paddingTop: "1rem",
        },
        "& .coverImage": {
            width: "100%",
        },
        "& .tell-us": {},
        "& .subHeadings": {
            fontWeight: "bold",
            fontSize: "1.4rem",
            paddingTop: "1rem",
            paddingBottom: "1rem",
        },
    },
}));
const StyledItem = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    minWidth: "fit-content",
    cursor: "pointer",
    "& a": {
        width: "100%",
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
    },
    "& span": { marginRight: "10px", color: theme.palette.text.primary },
}));

const FieldCard = ({ icon, label, value }) => {
    const display =
        value === null || value === undefined || value === "" ? "—" : value;
    return (
        <Box
            sx={{
                background: "#f5f6f4",
                border: "1px solid #e6e9e3",
                borderRadius: "12px",
                px: 1.75,
                py: 1.35,
                height: "100%",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.6 }}>
                <Box sx={{ display: "flex", alignItems: "center", color: "#5c6b7d" }}>
                    {icon}
                </Box>
                <Typography
                    sx={{
                        fontSize: "11px",
                        fontWeight: 700,
                        letterSpacing: "0.06em",
                        textTransform: "uppercase",
                        color: "#6b7280",
                        lineHeight: 1.1,
                    }}
                >
                    {label}
                </Typography>
            </Box>
            <Typography
                sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#111827",
                    lineHeight: 1.35,
                    wordBreak: "break-word",
                    textAlign: "center",
                }}
            >
                {display}
            </Typography>
        </Box>
    );
};

const ConfirmBooking = () => {
    const token = localStorage.getItem("accessToken");
    const { logout } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const bookingData = location.state?.bookingData;
    const bookingId = bookingData?.booking_id || bookingData?.id;
    const isLoggedIn = Boolean(token);
    return (
        <MainBox >
            <Box className="topHeader">
                <Container maxWidth="lg">
                    <Box
                        display={"flex"}
                        alignItems="center"
                        justifyContent={"space-between"}
                    >
                        <Box className="logoContainer">
                            <a href={token ? '/dashboard/default' : tenantServicesPageUrl()}>
                                <img
                                    src={Logo}
                                    alt="logo"
                                    className="logoImg"
                                    style={{ cursor: "pointer" }}
                                />
                            </a>
                        </Box>
                        <Box display={"flex"} alignItems="center">
                            <Box
                                display={"flex"}
                                alignItems="center"
                                sx={{ marginLeft: "1rem" }}
                            >
                                <StyledItem
                                    onClick={() => {
                                        if (token) logout();
                                        navigate('/session/signin');
                                    }}
                                >
                                    <Icon>{token ? 'power_settings_new' : 'login'}</Icon>
                                    <Span>{token ? 'Logout' : 'Sign in'}</Span>
                                </StyledItem>
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>
            <div style={{ background: 'linear-gradient(45deg, white 46%, #1976d29e 50%)', display: 'flex', justifyContent: 'center',height:"100vh" }}>
                <Grid container sx={{ backgroundColor: 'white', width: '95%', position: 'relative',  px: "30px !important", boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', py: "25px !important", mt: "105px !important",height:'max-content',mb:'10px !important' }}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                background: "#dddada1a",
                                padding: "3rem",
                                width: "100%",
                                border: "1px solid #dddada",
                                textAlign: "center",
                                "& a": {
                                    "&:hover": {
                                        textDecoration: "underline",
                                    },
                                },
                            }}
                        >
                            <Typography
                                variant="h4"
                                className="bookingTitle"
                                sx={{
                                    textTransform: "capitalize",
                                    fontSize: "1.75rem !important",
                                }}
                            >
                                Congratulations, your booking has been confirmed.
                            </Typography>
                            <Typography
                                variant="h5"
                                className="bookingTitle"
                                sx={{
                                    textTransform: "capitalize",
                                    fontSize: "1.25rem !important",
                                }}
                            >
                                Your booking ID: <b>{bookingData?.booking_id}</b>
                            </Typography>
                            {isLoggedIn && bookingId && <Typography
                                component={RouterLink}
                                to={`/dashboard/booking-appointments/${bookingId}/details/`}
                                variant="h5"
                                sx={{
                                    textTransform: "capitalize",
                                    fontSize: "1rem !important",
                                    marginTop: '5px !important',
                                    color: '#1976d2 !important',
                                    textDecoration: 'underline',
                                    marginBottom: '10px',
                                    display: 'inline-block',
                                }}
                            >
                                View Booking Details
                            </Typography>}
                            <Grid container spacing={4} sx={{ mt: '15px !important' }}>
                                <Grid item xs={12} lg={4}>
                                    <img src={CoverImage} alt="cover" className="coverImage" style={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <Grid container spacing={1.25}>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<PersonIcon sx={{ fontSize: 18 }} />}
                                                label="Name"
                                                value={`${bookingData?.contact_info?.first_name || ""} ${bookingData?.contact_info?.last_name || ""}`.trim()}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<EmailOutlinedIcon sx={{ fontSize: 18 }} />}
                                                label="E-mail"
                                                value={bookingData?.contact_info?.email}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<LocalPhoneOutlinedIcon sx={{ fontSize: 18 }} />}
                                                label="Phone no."
                                                value={formatPhoneNumber(
                                                    stringReplace(
                                                        stringReplace(bookingData?.contact_info?.phone, `('`, ""),
                                                        `',)`,
                                                        ""
                                                    ) || ""
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<LocationCityIcon sx={{ fontSize: 18 }} />}
                                                label="City"
                                                value={bookingData?.service_location?.city}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<EmojiTransportationIcon sx={{ fontSize: 18 }} />}
                                                label="State"
                                                value={bookingData?.service_location?.state}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<TagIcon sx={{ fontSize: 18 }} />}
                                                label="Zip Code"
                                                value={bookingData?.service_location?.zip_code}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<HomeOutlinedIcon sx={{ fontSize: 18 }} />}
                                                label="Address"
                                                value={bookingData?.service_location?.street_address}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<InfoIcon sx={{ fontSize: 18 }} />}
                                                label="Description"
                                                value={bookingData?.additional_info}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <Grid container spacing={1.25}>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<BookmarkIcon sx={{ fontSize: 18 }} />}
                                                label="Booking Type"
                                                value={bookingData?.booking_type}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<LocalParkingIcon sx={{ fontSize: 18 }} />}
                                                label="Parking Spot"
                                                value={bookingData?.contact_info?.do_parking_spot ? "Yes" : "No"}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<PetsIcon sx={{ fontSize: 18 }} />}
                                                label="Pet"
                                                value={bookingData?.contact_info?.do_you_pets}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FieldCard
                                                icon={<CalendarMonthIcon sx={{ fontSize: 18 }} />}
                                                label="Date/Time"
                                                value={`${moment(bookingData?.start_date).format("MMM DD, YYYY")} ${bookingData?.start_time || ""}`.trim()}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FieldCard
                                                icon={<KeyIcon sx={{ fontSize: 18 }} />}
                                                label="How will we get in?"
                                                value={bookingData?.contact_info?.how_to_enter_on_premise}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Box
                                display={"flex"}
                                alignItems="center"
                                justifyContent={"end"}
                                sx={{ mb: 2, mt: 3 }}
                                position="absolute"
                                bottom='15px'
                                right='40px'
                            >
                            {
                            isLoggedIn ?
                                <LoadingButton
                                    color="primary"
                                    variant="contained"
                                    onClick={() => navigate('/dashboard/default')}
                                >
                                    Go to Dashboard
                                </LoadingButton>:
                                <LoadingButton
                                    color="primary"
                                    variant="contained"
                                    onClick={() => navigate(tenantPublicPageUrl('signup'), { state: { email: bookingData?.contact_info?.email } })}
                                >
                                    Create an account to access your dashboard
                                </LoadingButton>

                            }

                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </div>

        </MainBox>

    )
}

export default ConfirmBooking
